import script from "./ProtocolScript.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtocolScript.vue?vue&type=script&setup=true&lang=ts"

import "./ProtocolScript.vue?vue&type=style&index=0&id=d11b1252&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d11b1252"]])

export default __exports__